import { ModuleAccessGuard } from '@/components/ModuleAccessGuard';

export default function Support() {
  return (
    <ModuleAccessGuard moduleId="support">
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Priority Support</h1>
          <p className="text-muted-foreground mt-2">
            24/7 priority support and dedicated account management.
          </p>
        </div>
        <div className="text-center text-muted-foreground">
          Support dashboard coming soon.
        </div>
      </div>
    </ModuleAccessGuard>
  );
}